import { isHubEnabled, type HubFeatureFlags } from '@/config/featureFlags';

export function getVisibleHomeHubs<T extends { id: string }>(
  homeHubs: readonly T[],
  canViewHub: (hubId: string) => boolean,
  flags?: HubFeatureFlags,
): T[] {
  return homeHubs.filter((hub) => canViewHub(hub.id) && isHubEnabled(hub.id, flags));
}
